export const formatDate = (dateString: string): string => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    } catch {
      return dateString;
    }
};

export const formatDateTime = (dateString: string) => {
    try {
      if (dateString && !dateString.endsWith('Z') && !dateString.includes('+')) {
        dateString += 'Z';
      }
      const date = new Date(dateString);

      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    } catch {
      return dateString;
    }
  };